<p class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-text-200 tw-font-normal tw-text-gray-500">
  <em class="cs-icon-lock tw-text-300"></em>
  <span class="tw-lowercase" i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
</p>
